export const STORE_DETAILS = 'STORE_DETAILS';
export const storeDetails = (details) => ({
  type: STORE_DETAILS,
  details,
});

export const RESET_DETAILS = 'RESET_DETAILS';
export const resetDetails = () => ({
  type: RESET_DETAILS,
  details: null,
});
